import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from '../../AxiosClient'

export const checkUser = createAsyncThunk(
  'login/check-user',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/common/check-user`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getDefaultRoutes = createAsyncThunk(
  'login/getDefaultRoutes',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', `/v1/common/get-user-with-default-route`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getAllRoutes = createAsyncThunk(
  'config/getAllRoutes',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    let url = `/v1/app-config/get-config`
    return await AxiosClient('GET', url, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
